import BaseService from './base'

export default class GenericProductService extends BaseService {
  static resource() {
    return 'api/v1/external/genericProducts'
  }
}
